// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ImportProjectSchema = z.object({
  id: z.number().int().describe("Unique identifier for the project in the external system"),
  name: z.coerce.string().describe("Name of the project"),
});
